var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("権限不足です。")]),_c('p',[_vm._v("5秒後にTOPページへ遷移します。")])])
}]

export { render, staticRenderFns }